import React, { useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { debounce } from 'lodash/fp';
import { unescape } from 'lodash';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const QuestionWithMetadata = ({
  questionData,
  isZendesk,
  questionType,
  zendeskSupportLogo,
  applyChanges,
  handleUpdate,
}) => {
  const initialState = {
    sender: questionData?.from || questionData?.requester,
    subject: questionData?.subject || '',
    body: questionData?.body || '',
  };

  const [messageData, setMessageData] = useState(initialState);

  const i18n = useSelector(state => state.editor.i18n.questions.question);

  const saveQuestion = incomingData => {
    let dataToSend;

    const data = {
      from: incomingData.sender,
      subject: incomingData.subject,
      body: incomingData.body,
    };

    if (isZendesk) {
      dataToSend = {
        zendesk_question_metadata: {
          requester_name: incomingData.sender,
          subject: incomingData.subject,
          description: incomingData.body,
        },
        raw_choices: JSON.stringify(data),
      };
    } else {
      dataToSend = {
        raw_choices: JSON.stringify(data),
      };
    }

    applyChanges(dataToSend);
    handleUpdate(dataToSend);
  };
  const debouncedSaveQuestion = useRef(debounce(300, saveQuestion)).current;

  const handleMessageChange = (e, target) => {
    const { value } = e.target;
    const messageCopy = { ...messageData };
    messageCopy[target] = value;
    setMessageData(messageCopy);
    debouncedSaveQuestion(messageCopy);
  };

  const fieldClasses =
    'QuestionWithMetadata-field QuestionWithMetadata--fieldWithLabel';
  const displaySenderField = questionType === 'email_reply' || isZendesk;
  const contentFieldLabel = isZendesk
    ? i18n.ticket_handling.zendesk.description
    : i18n.email_composition.body;
  const senderFieldLabel = isZendesk
    ? i18n.ticket_handling.zendesk.requester
    : i18n.email_reply.lesson_builder.sender;
  const instructions = isZendesk
    ? i18n[questionType].zendesk.content
    : i18n[questionType].lesson_builder.instructions;

  return (
    <div>
      {isZendesk && (
        <img
          alt="zendesk support logo"
          className="QuestionWithMetadata--zendeskSupportLogo mt-15"
          src={zendeskSupportLogo}
        />
      )}
      <div className="EditorElement-label">{instructions}</div>
      <div className="QuestionWithMetadata QuestionWithMetadata--lessonBuilder">
        {displaySenderField && (
          <div className={fieldClasses}>
            <div className="QuestionWithMetadata-fieldLabel">
              {senderFieldLabel}
            </div>
            <Text
              variant={TEXT_VARIANTS.BODY_BOLD}
              component="input"
              onChange={e => {
                handleMessageChange(e, 'sender');
              }}
              value={unescape(messageData.sender)}
            />
          </div>
        )}
        <div className={fieldClasses}>
          <div className="QuestionWithMetadata-fieldLabel">
            {i18n.email_practice.subject}
          </div>
          <Text
            variant={TEXT_VARIANTS.SUBHEADER_BOLD}
            component="input"
            onChange={e => {
              handleMessageChange(e, 'subject');
            }}
            value={unescape(messageData.subject)}
          />
        </div>
        <div className={fieldClasses}>
          <div className="QuestionWithMetadata-fieldLabel">
            {contentFieldLabel}
          </div>
          <Text
            variant={TEXT_VARIANTS.SUBHEADER}
            component="textarea"
            onChange={e => {
              handleMessageChange(e, 'body');
            }}
            value={unescape(messageData.body)}
          />
        </div>
      </div>
    </div>
  );
};

export default QuestionWithMetadata;
